/**
 * WordPress dependencies
 */
import { BlockIcon } from '@wordpress/block-editor';
import { gallery as icon } from '@wordpress/icons';

export const sharedIcon = <BlockIcon icon={ icon } />;
